/**
 * Birth weekday (vara) from the stored local birth date.
 *
 * Mirrors calculate_weekday() in the chart-calculator lambda. Computed on the
 * client rather than read from chartData.weekday because charts are cached in
 * localStorage: any chart generated before the weekday fix derived the vara
 * from the UTC Julian Day, so a birth before 05:30 IST (or late evening in a
 * negative-offset zone) carries the previous or next day — and the wrong lord
 * with it.
 */

const WEEKDAYS = [
  { day: 'Monday', lord: 'Moon' },
  { day: 'Tuesday', lord: 'Mars' },
  { day: 'Wednesday', lord: 'Mercury' },
  { day: 'Thursday', lord: 'Jupiter' },
  { day: 'Friday', lord: 'Venus' },
  { day: 'Saturday', lord: 'Saturn' },
  { day: 'Sunday', lord: 'Sun' },
];

/**
 * @returns {{day, lord, number}|null} null when the chart has no usable local
 * birth date, so callers can fall back to whatever is stored.
 */
export function resolveWeekday(chartData) {
  const dateStr = chartData?.birth_details?.date;
  if (!dateStr) return null;

  const parts = String(dateStr).split('-');
  if (parts.length !== 3) return null;

  const year = Number(parts[0]);
  const month = Number(parts[1]);
  const day = Number(parts[2]);
  if (![year, month, day].every(Number.isFinite)) return null;
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;

  // JD at local midnight, then modulo 7. JD 0.0 was a Monday and begins at
  // noon, hence the +0.5 shift.
  let y = year;
  let m = month;
  if (m <= 2) {
    y -= 1;
    m += 12;
  }
  const a = Math.floor(y / 100);
  const b = 2 - a + Math.floor(a / 4);
  const jdLocalMidnight =
    Math.floor(365.25 * (y + 4716)) + Math.floor(30.6001 * (m + 1)) + day + b - 1524.5;

  const index = Math.floor((jdLocalMidnight + 0.5) % 7);
  const entry = WEEKDAYS[index];
  return entry ? { ...entry, number: index + 1 } : null;
}

export default resolveWeekday;
